import React, { useState } from "react";
import { useForm } from "react-hook-form";

import {
  Row,
  Col,
  Input,
  FormFeedback,
  FormText,
  Button,
  FormGroup,
  Label,
} from "reactstrap";

import attorneyService from "../../services/attorneyService";

const UpdatePassword = () => {
  const { register, handleSubmit, errors } = useForm();

  const [formState, setFormState] = useState({
    oldPassword: "",
    newPassword: "",
    newPasswordConfirm: "",
  });

  const onChange = (evt) => {
    const { target } = evt;
    if (target) setFormState({ ...formState, [target.name]: target.value });
  };

  const onSubmit = (data) => {
    if (formState.newPassword !== formState.newPasswordConfirm) {
      return;
    }
    attorneyService.updatePassword(formState);
  };

  return (
    <React.Fragment>
      <Row>
        <Col xs={12}>
          <h1>Update password</h1>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>
            Update your password here. Once you make your change you will be
            logged off and will need to log back in.
          </p>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <FormGroup row>
              <Label sm={12}>Current password</Label>
              <Col sm={12}>
                <React.Fragment>
                  <Input
                    type="password"
                    name="oldPassword"
                    value={formState.oldPassword}
                    style={{ width: "90%" }}
                    onChange={(evt) => onChange(evt)}
                    innerRef={register({
                      required: true,
                      min: 6,
                      pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{6,})/,
                    })}
                    invalid={errors.oldPassword ? true : false}
                  />
                  <FormText>
                    Passwords must contain an uppercase character, lowercase
                    character, a digit, and a non-alphanumeric character and at
                    least six characters long.
                  </FormText>
                  {errors.oldPassword && (
                    <FormFeedback>
                      Your password does not meet the minimum requirements.
                    </FormFeedback>
                  )}
                </React.Fragment>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={12}>New password</Label>
              <Col sm={12}>
                <React.Fragment>
                  <Input
                    type="password"
                    name="newPassword"
                    value={formState.newPassword}
                    style={{ width: "90%" }}
                    onChange={(evt) => onChange(evt)}
                    innerRef={register({
                      required: true,
                      min: 6,
                      pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{6,})/,
                    })}
                    invalid={errors.newPassword ? true : false}
                  />
                  <FormText>
                    Passwords must contain an uppercase character, lowercase
                    character, a digit, and a non-alphanumeric character and at
                    least six characters long.
                  </FormText>
                  {errors.newPassword && (
                    <FormFeedback>
                      Your password does not meet the minimum requirements.
                    </FormFeedback>
                  )}
                </React.Fragment>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={12}>Confirm new password</Label>
              <Col sm={12}>
                <React.Fragment>
                  <Input
                    type="password"
                    name="newPasswordConfirm"
                    value={formState.newPasswordConfirm}
                    style={{ width: "90%" }}
                    onChange={(evt) => onChange(evt)}
                    innerRef={register({
                      required: true,
                      min: 6,
                      pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{6,})/,
                    })}
                    invalid={errors.newPasswordConfirm ? true : false}
                  />
                  <FormText>
                    Passwords must contain an uppercase character, lowercase
                    character, a digit, and a non-alphanumeric character and at
                    least six characters long.
                  </FormText>
                  {errors.newPasswordConfirm && (
                    <FormFeedback>
                      Your password does not meet the minimum requirements.
                    </FormFeedback>
                  )}
                  {formState.newPassword !== formState.newPasswordConfirm && (
                    <FormFeedback>
                      Your new password and the confirm new password do not
                      match.
                    </FormFeedback>
                  )}
                </React.Fragment>
              </Col>
            </FormGroup>
            <Button type="submit">Submit</Button>
          </form>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default UpdatePassword;
